import React, { forwardRef, useEffect, useState } from "react";

// js
import "../assets/js/main.min.js";

//router
import { NavLink as Link, useHistory, useRouteMatch } from "react-router-dom";

// css
import "../assets/css/main.min.css";
import "../assets/css/custom.css";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// component

import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../store/admin/action.js";
import man from "../assets/images/male.png";
import moment from "moment";
import {
  getHostEarning,
  getHosthistory,
} from "../store/history/history.action.js";
import DailyIncome from "./history/DailyIncome.js";
import RoomData from "./history/RoomData.js";
import VideoCall from "./history/VideoCall.js";
import rCoin from "../assets/images/shell.png";
import leftArrow from "../assets/images/leftArrow.png";
// import { getLiveRoomHistory } from "../store/liveRoom/action.js";
// import { getChatRoomHistory } from "../store/chatRoom/action.js";
import { getVideoCallHistory } from "../store/videoCall/action.js";
import { permissionError } from "../util/Alert.js";
import { Toast } from "../util/Toast.js";
import HostSettlement from "./HostSettlement.js";
import gredientImage from "../assets/images/pinkcard.png";
import gredientImage1 from "../assets/images/purplecard.png";
import dashBg from "../assets/images/dash-bg.png";
import Diamond from "../assets/images/diamon.png";
import Copy from "../assets/images/copy.svg";
import useTranslation from "../hooks/useTranslation";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";

const Admin = () => {
  // colors pulled together for quick tweaking
  const UI = {
    bg: "transparent",
    headerBg: "transparent",
    cardEdge: "rgba(255,255,255,0.1)",
    cardBg: "rgba(55, 30, 75, 0.72)",
    cardBgTop: "rgba(55, 30, 75, 0.72)",
    accent: "#FFFFFF",
    subtext: "#FFFFFFA3",
    text: "#FFFFFF",
    tabInactive: "#FFFFFF",
    pillText: "#7B2CBF",
    gradient:
      "linear-gradient(90deg, #e91e8c 0%, #9b3dcf 100%)",
    softGlow: "0 8px 24px rgba(255, 28, 96, 0.35), 0 2px 8px rgba(0,0,0,0.25)",
  };

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const admin = useSelector((state) => state.admin.seller);
  const hostHistory = useSelector((state) => state.history.hostHistory);
  const hostId = localStorage.getItem("hostId");

  const currentMonth = moment().format("YYYY-MM");

  const [selectedDate, setSelectedDate] = useState(currentMonth);
  const [type, setType] = useState(1);

  useEffect(() => {
    dispatch(getProfile(hostId));
    dispatch(getHosthistory(currentMonth, hostId));
    // dispatch(getHostEarning(hostId, currentMonth));
    dispatch(getVideoCallHistory(hostId, currentMonth));
    // dispatch(getChatRoomHistory(hostId, currentMonth));
    // dispatch(getLiveRoomHistory(hostId, currentMonth));
  }, [dispatch, currentMonth, hostId]);

  const handleDateChange = (date) => {
    const selectedDateObject = moment(date).format("YYYY-MM");
    setSelectedDate(selectedDateObject);
    dispatch(getHosthistory(selectedDateObject, hostId));
    // dispatch(getHostEarning(hostId, selectedDateObject));
    dispatch(getVideoCallHistory(hostId, selectedDateObject));
    // dispatch(getChatRoomHistory(hostId, selectedDateObject));
    // dispatch(getLiveRoomHistory(selectedDateObject));
  };

  const handleBack = () => {
    window.showAndroidToast();
  };

  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <button
      onClick={onClick}
      ref={ref}
      // pill like in the screenshot
      style={{
        border: "none",
        borderRadius: 12,
        padding: "12px 16px",
        fontWeight: 600,
        fontSize: 14,
        background: "#FFFFFF",
        color: UI.pillText,
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        lineHeight: 1,
        cursor: "pointer",
      }}
      className="shadow-sm"
    >
      {value}
    </button>
  ));

  const handleCopy = async (link) => {
    if (admin?.isActive === false) return permissionError();
    try {
      await navigator.clipboard.writeText(link);
      Toast("success", `Copy Success.`);
    } catch (error) {
      console.error("Copy failed:", error);
      Toast("error", "Copy Failed");
    }
  };

  return (
    <>
      <div
        className="page-container"
        style={{ background: "transparent", minHeight: "100vh" }}
      >
        <div className="page" style={{ background: "transparent" }}>
          <div className="main-wrapper p-0" style={{ background: "transparent" }}>
            <div className="main-section" style={{ background: "transparent" }}>
              {/* Header — matches design: transparent, circular back, centered title */}
              <div
                className="host-center-header d-flex align-items-center justify-content-between px-3"
                style={{
                  zIndex: 9,
                  position: "fixed",
                  width: "100%",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: 56,
                  background: "transparent",
                  borderBottom: "none",
                }}
              >
                <div className="d-flex align-items-center">
                  <div
                    className="host-back-btn"
                    onClick={handleBack}
                  >
                    <svg
                      width="10"
                      height="12"
                      viewBox="0 0 10 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.5 1.5L1.5 8L8.5 14.5"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>

                  <p
                    className="fw-bold mb-0 ms-3"
                    style={{
                      fontSize: "18px",
                      fontWeight: 700,
                      color: "#FFFFFF",
                      letterSpacing: 0.2,
                      lineHeight: 1,
                    }}
                  >
                    {t("host_center")}
                  </p>
                </div>

                <div className="host-lang-switcher">
                  <LanguageSwitcher variant="header" />
                </div>
              </div>

              <div className="" style={{ paddingTop: 64, paddingBottom: 24 }}>
                {/* Profile card — gradient + dash-bg overlay */}
                <div className="responsive-bg">
                  <img src={dashBg} alt="" className="dash-bg-overlay" />
                  <div className="dash-bg-content d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center p-3">
                      <img
                        src={admin?.image ? admin?.image : man}
                        onError={(e) => { e.target.src = man; }}
                        style={{
                          height: 56,
                          width: 56,
                          objectFit: "cover",
                          borderRadius: "50%",
                          // border: "2px solid rgba(250, 250, 250, 1)",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
                        }}
                        alt=""
                      />
                      <div className="ms-3">
                        <p
                          className="mb-0 text-white"
                          style={{
                            fontSize: 16,
                            fontWeight: 800,
                            lineHeight: 1,
                          }}
                        >
                          {admin?.name ? admin?.name : "-"}
                        </p>
                        <p
                          className="mb-0 mt-1"
                          style={{
                            fontSize: 12,
                            color: UI.subtext,
                            fontWeight: 500,
                          }}
                        >
                          {t("unique_id")} : {admin?.uniqueId}
                        </p>
                      </div>
                    </div>

                    <div className="date-picker d-flex justify-content-end p-3">
                      <DatePicker
                        selected={selectedDate}
                        dateFormat="MM/yyyy"
                        showMonthYearPicker
                        onChange={(date) => handleDateChange(date)}
                        customInput={<ExampleCustomInput />}
                        popperPlacement="bottom-end"
                        portalId="root-portal"
                      />
                    </div>
                  </div>
                </div>

                {/* Diamond + incomes card */}
                <div className="host-stats-card mt-3">
                  <div className="host-stats-row">
                    <h3 className="host-stats-label">{t("diamond")}</h3>
                    <p className="host-stats-value">
                      <img
                        src={Diamond}
                        alt=""
                        height={20}
                        width={24}
                        style={{ marginRight: 8 }}
                      />
                      {admin?.diamond ? admin?.diamond.toFixed(0) : 0}
                    </p>
                  </div>

                  <div className="host-stats-row">
                    <h3 className="host-stats-label">{t("this_week_income")}</h3>
                    <p className="host-stats-value">
                      <img
                        src={rCoin}
                        alt=""
                        height={20}
                        width={22}
                        style={{ marginRight: 8 }}
                      />
                      {admin?.rCoin ? admin?.rCoin.toFixed(0) : 0}
                    </p>
                  </div>

                  <div className="host-stats-row">
                    <h3 className="host-stats-label">{t("spent_coin")}</h3>
                    <p className="host-stats-value">
                      <img
                        src={rCoin}
                        alt=""
                        height={20}
                        width={22}
                        style={{ marginRight: 8 }}
                      />
                      {admin?.rCoin ? admin?.spentCoin.toFixed(0) : 0}
                    </p>
                  </div>
                </div>

                {/* My Agency — exact match to design */}
                <p className="host-section-title">{t("my_agency")}</p>
                <div className="responsive-bg2 my-agency-card">
                  <img src={dashBg} alt="" className="dash-bg-overlay" />
                  <div className="dash-bg-content my-agency-card-inner">
                    <img
                      className="my-agency-avatar"
                      src={
                        !admin?.hostAgency?.image?.includes("\\")
                          ? admin?.hostAgency?.image
                          : man
                      }
                      onError={(e) => { e.target.src = man; }}
                      alt=""
                    />
                    <div className="my-agency-info">
                      <h6 className="my-agency-name">
                        {admin?.hostAgency?.name
                          ? admin?.hostAgency?.name
                          : "-"}
                      </h6>
                      <p className="my-agency-id">
                        {t("unique_id", "Unique ID")}:{" "}
                        {admin?.hostAgency?.uniqueId
                          ? admin?.hostAgency?.uniqueId
                          : "-"}
                      </p>
                      {/* <button
                            className="ms-1 pe-0"
                            style={{
                              border: "none",
                              backgroundColor: "transparent",
                              lineHeight: 0,
                            }}
                            onClick={() =>
                              handleCopy(admin?.hostAgency?.uniqueId)
                            }
                            aria-label={t("Copy agency ID")}
                            title={t("Copy")}
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10 2.5H3C2.17157 2.5 1.5 3.17157 1.5 4V14C1.5 14.8284 2.17157 15.5 3 15.5H10C10.8284 15.5 11.5 14.8284 11.5 14V4C11.5 3.17157 10.8284 2.5 10 2.5Z"
                                fill="white"
                              />
                              <path
                                d="M14.4998 2V12C14.4987 12.3975 14.3402 12.7783 14.0592 13.0593C13.7781 13.3404 13.3973 13.4988 12.9998 13.5H12.4998V4C12.4998 3.33696 12.2365 2.70107 11.7676 2.23223C11.2988 1.76339 10.6629 1.5 9.99984 1.5H4.58984C4.693 1.20823 4.88388 0.955499 5.13631 0.776469C5.38874 0.597439 5.69037 0.50087 5.99984 0.5H12.9998C13.3973 0.501187 13.7781 0.659603 14.0592 0.940651C14.3402 1.2217 14.4987 1.60254 14.4998 2Z"
                                fill="white"
                              />
                            </svg>
                          </button> */}
                    </div>
                  </div>
                </div>

                {/* Tabs — pill style */}
                <div className="host-tabs">
                  {/* <TabLabel
                    label={t("payment_history")}
                    active={type === 2}
                    onClick={() => setType(2)}
                  /> */}
                  <TabLabel
                    label={t("daily_income")}
                    active={type === 1}
                    onClick={() => setType(1)}
                  />
                  <TabLabel
                    label={t("call")}
                    active={type === 3}
                    onClick={() => setType(3)}
                  />
                </div>

                {/* Content (unchanged functionality) */}
                {type === 1 && (
                  <div key="daily" className="host-tab-content">
                    <DailyIncome />
                  </div>
                )}
                {type === 2 && (
                  <div key="settlement" className="host-tab-content">
                    <HostSettlement />
                  </div>
                )}
                {type === 3 && (
                  <div key="call" className="host-tab-content">
                    <VideoCall />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// Small presentational component for tab label (no logic change)
const TabLabel = ({ label, active, onClick }) => {
  return (
    <div
      className={`host-tab-pill${active ? " active" : ""}`}
      onClick={onClick}
    >
      {label}
    </div>
  );
};

export default Admin;
